export enum ZIndex {
  Hidden = '-1',
  Zero = '0',
  Min = '1',
  BoxesSliderArrows = '10',
  InputLabelSpan = '11',
  AutosuggestSuggestionsList = '12',
  QuoteCarouselArrows = '20',
  FixedButton = '21',
  SlideMenu = '50',
  // over overlay
  Tooltip = '101',
  CookiesPopup = '200',
  FixedTextBoxes = '210',
  HeaderMenu = '600',
  Overlay = '640',
  HeaderMenuMobileBox = '641',
  BasketSidePanel = '642',
  OnTopSimpleMenu = '645',
  Filters = '650',
  SmallDialog = '660',
  Dropdown = '700',
  FullscreenDropdown = '710',
  FullscreenPopup = '720',
  Toasts = '800',
  PhotosSliderFullSize = '810',
  PhotosSliderFullSizeButtons = '820',
  LoadingSpinner = '1000',
}
